import $http from '../../axios-instance';
import {getAcls} from '../../plugins/acl';
import $httpAri from '../../axios-instance-ari';

/**
 * Método para obtener la información de las graficas Un sga y NFPA.
 *
 * @param {*} param0
 */
export async function getGraficas({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http.get(`graphics/complete`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setGraficas', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}


/**
 * Método para obtener la información de las graficas de documentos FdsMsds.
 *
 * @param {*} param0
 */
export async function getFdsMsds({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http.get(`graphics/fds-msds`)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setGraficasFdsMsds', response.data.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Validar si el usuario tiene un permiso
 *
 * @param permiso Contiene el permiso a validar
 * @returns {boolean} Contiene la validación del permiso
 * @author Jhon García
 */
export function validarPermiso({}, permiso) {
  const acls = getAcls();

  return !!acls.permisos.find(p => p === permiso);
}

/**
 * Obtener el id de la empresa asociada al usuario autenticado
 *
 * @returns {int} Contiene el id de la empresa
 * @author Jhon García
 */
export async function obtenerIdEmpresaUsuario({}) {
  const acls = getAcls();

  return acls.empresa;
}

/**
 * Metodo que devuelve todas las notificaciones no leidas.
 *
 * @returns {array} Contiene las notificaciones no leidas.
 * @author Brandon Torres
 */
 export async function notificationsUnread({commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`notificaciones/unread`)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        localStorage.setItem('notifylocalStorage', JSON.stringify(response.data))
        commit('setNotificationsUnread')
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
    });
}

/**
 * Metodo que marca la notificación como leida.
 *
 * @param {int} id_notification de la notificación.
 * @author Brandon Torres
 */
export async function notificationMarkAsRead({commit, dispatch}, id_notification) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`notificaciones/markAsRead/`+id_notification).then(async (response) => {
        commit('dashboard/load', false, {root: true});
        await dispatch('notificationsUnread')
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
    });
}



/**
 * Metodo que trae la información de la grafica de la sección 1 del dashboard.
 * @param {*} payload
 */
export async function findDataDash1({ commit }, payload) {

    try {
        const response = await $http.get("dashboard/get-info-dash-1", {
            params: payload
        });
        commit("setDataDash1", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    }
}

/**
 * Metodo que trae la información de la grafica de la sección 2 del dashboard.
 * @param {*} payload
 */
export async function findDataDash1Priority({ commit }, payload) {
    try {
        const response = await $httpAri.post("get-task-by-dashboard-1", payload);
        commit("setDataDash1Priority", response.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    }
}

/**
 * Metodo que trae la información de la grafica de la sección 2 del dashboard.
 * @param {*} payload
 */
export async function findDataDash2({ commit }, payload) {
    try {
        const response = await $http.get("dashboard/get-info-dash-2", {
            params: payload
        });
        commit("setDataDash2", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    }
}

/**
 * Metodo que trae la información de los productos afectados del dashboard.
 * @param {*} payload
 */
export async function findDataProducts({ commit }, payload) {
    try {
        const response = await $http.get("dashboard/get-products-by-company-and-affectation", {
            params: payload
        });
        commit("setProductsDashAffected", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    }
}
